/**
 * Declarative config of `extranet.sidebarMenu` — the navigation entries of
 * the extranet sidebar (desktop) and of the mobile drawer.
 *
 * Every entry carries the **stable key** of {@link EXTRANET_NAV_ITEMS}
 * (`accueil`, `contrats`, `sinistres`, `primes`, `flotte`, `pieces`) — the
 * contract a layout rule targets — separate from its display `label`, which
 * is overridable (rename / hide / reorder / tooltip through the info-item
 * bucket). Labels, order and tooltips live here, never inline in JSX.
 */

import { EXTRANET_NAV_ITEMS, type ExtranetNavItem } from '../../navigation';

/** Registered id of the navigation menu. */
export const SIDEBAR_MENU_ID = 'extranet.sidebarMenu';

/**
 * Base component title. Published (so the layout editor offers the title
 * slot) but **not rendered** at baseline: a `setTitle` rule adds it as a
 * section heading above the entries.
 */
export const SIDEBAR_MENU_TITLE = 'Menu';

/** One menu entry (declarative config). */
export interface SidebarMenuItemDescriptor extends ExtranetNavItem {
  /** Sort order (lower first). */
  order: number;
  /** `false` ⇒ hidden (a `hideField` rule; revealable with `showField`). */
  visible?: boolean;
  /** Tooltip shown on hover of the expanded entry (`setFieldTooltip`). */
  tooltip?: string;
}

/** The six entries of the design, in order (`order` = design position). */
export const SIDEBAR_MENU_ITEMS: readonly SidebarMenuItemDescriptor[] = EXTRANET_NAV_ITEMS.map(
  (item, index) => ({ ...item, order: index }),
);
